// Example: datestring = '2506' // ----> June 2025
export const getCardExpirationDate = (dateString) => {
    if (!dateString)
        return { expirationString: '' };
    const year = dateString.slice(0, 2);
    const month = dateString.slice(2);
    return {
        expirationString: `${month}/20${year}`,
    };
};
//# sourceMappingURL=card.js.map